import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { OnbudsmanComponent } from './onbudsman.component';


const routes: Routes = [
  { 
      path: '', component: OnbudsmanComponent,
      children: [
        { path: 'onbudsman', component: OnbudsmanComponent },
      ]
  }
];

@NgModule({
  imports: [
      RouterModule.forChild(routes)
    ],
  exports: [
      RouterModule
    ]
})
export class OnbudsmanRoutingModule { }
